/**
 * P2 Pre-Live Checklist Stage 1 화면 (read-only).
 *
 * 체크리스트 문서를 운영 기능으로 승격. 매 호출 시 P1 overview + P3 summary 합성.
 * 사용자 입력 저장 없음 — Stage 2/3에서 추가.
 */
import { useCallback, useEffect, useState } from 'react';
import ChecklistSummaryBar from '../components/checklist/ChecklistSummaryBar';
import ChecklistSections from '../components/checklist/ChecklistSections';
import {
  ChecklistResponse,
  fetchChecklistStatus,
} from '../services/checklistApi';
import './Checklist.css';

export default function Checklist() {
  const [data, setData] = useState<ChecklistResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await fetchChecklistStatus());
    } catch (err) {
      setError(err instanceof Error ? err.message : '체크리스트 조회 실패');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading && !data) {
    return <div className="ck-page"><div className="state-box">체크리스트 평가 중...</div></div>;
  }

  if (error && !data) {
    return (
      <div className="ck-page">
        <div className="state-box error-state">API 오류: {error}</div>
        <button className="ck-refresh" onClick={load}>다시 시도</button>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="ck-page">
      <header className="ck-header">
        <div>
          <h1>Pre-Live Checklist</h1>
          <p>
            LIVE 전환 전 자동 판정 체크리스트 (Stage 1 · read-only) ·
            {' '}{new Date(data.generated_at).toLocaleString('ko-KR')} 평가
          </p>
        </div>
        <button className="ck-refresh" onClick={load} disabled={loading}>
          {loading ? '갱신 중...' : '재평가'}
        </button>
      </header>

      {error && (
        <div className="state-box error-state ck-banner">
          최신 조회 실패: {error} (이전 데이터 표시 중)
        </div>
      )}

      <ChecklistSummaryBar summary={data.summary} />
      <ChecklistSections items={data.items} />

      <footer className="ck-footer">
        <p>
          <strong>Stage 1 한계</strong>: 사용자 입력 저장 / 시계열 추적 없음.
          Telegram 알림 실제 수신은 사용자가 직접 확인 (manual).
          신규 BUY DecisionRecord (V1) / STRATEGY_SELL profit (V2) 적재는 paper 운영 누적 후 자동 pass.
        </p>
      </footer>
    </div>
  );
}
